import { useMutation } from '@apollo/client';
import type { VariablesOf } from '@graphql-typed-document-node/core';
import { SessionActions } from '../../account/sessionSlice';
import useAppSelector, { useAppDispatch } from '../../app/redux/useAppSelector';
import { gql } from '../../graphql/generated/gql';

const USER_PROFILE_MUTATION = gql(/** @complexity 4 */ `
  mutation updateUserProfile(
    $id: ID!
    $avatar: Upload
    $name: String
    $title: String
    $description: Json
  ) {
    updateUser(
      id: $id
      avatar: $avatar
      name: $name
      title: $title
      description: $description
    ) {
      id
      name
      title
      description
      avatar {
        original
        thumb
      }
    }
  }
`);

interface UseUpdateUserProfileParams {
  user: { id: string };
}

const useUpdateUserProfile = ({ user }: UseUpdateUserProfileParams) => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector((state) => state.session.user);

  const [update] = useMutation(USER_PROFILE_MUTATION);

  return (variables: Partial<VariablesOf<typeof USER_PROFILE_MUTATION>>) =>
    update({ variables: { ...variables, id: user.id } }).then(({ data }) => {
      if (data?.updateUser && currentUser.id === data.updateUser.id) {
        // @ts-expect-error
        dispatch(SessionActions.setCurrentUser(data.updateUser));
      }

      return data?.updateUser;
    });
};

export default useUpdateUserProfile;
